import { Component, Input, Output, EventEmitter } from '@angular/core';

import { EmailScheduleService } from './email-schedule.service';

@Component({
  selector: 'email-schedule',
  template: require('./email-schedule.component.html'),
  styles: [require('./email-schedule.component.scss')],
  providers: [EmailScheduleService]
})
export class EmailScheduleComponent {
  // saved state
  savedEmailSchedule: any;
  scheduleId: string = '';
  savedScheduleType = 'portPair';

  scheduleType: string = 'portPair';

  message: string = '';
  showRoutes: boolean = false;

  inputOne: string = '';
  inputTwo: string = '';

  originName: string = '';
  originId: number = 0;
  destinationName: string = '';
  destinationId: number = 0;

  @Output() status: EventEmitter<any> = new EventEmitter();
  @Output() scheduleChange: EventEmitter<any> = new EventEmitter();

  constructor(private service: EmailScheduleService) {
    // Do stuff
  }

  @Input()
  set delivery(schedule: string) {
    this.savedEmailSchedule = schedule;
    this.scheduleId = this.savedEmailSchedule.id;
    this.savedScheduleType = this.savedEmailSchedule.type;

    this.scheduleType = this.savedScheduleType;
    if (this.scheduleType === 'portPair') {
      this.inputOne = this.savedEmailSchedule.originPort.name;
      this.originId = this.savedEmailSchedule.originPort.id;
      this.originName = this.savedEmailSchedule.originPort.name;
      this.inputTwo = this.savedEmailSchedule.destinationPort.name;
      this.destinationId = this.savedEmailSchedule.destinationPort.id;
      this.destinationName = this.savedEmailSchedule.destinationPort.name;
    } else if (this.scheduleType === 'port') {
      this.inputOne = this.savedEmailSchedule.port.name;
    } else if (this.scheduleType === 'vessel') {
      this.inputOne = this.savedEmailSchedule.vessel.name;
    }
  }

  onStatusChange(state: string) {
    this.message = state;
    this.status.emit(state);
  }

  onScheduleChange(schedule: any) {
    this.scheduleChange.emit(schedule);
  }

  update(type: string, item: any) {
    if (type === 'origin') {
      this.originId = item.id;
      this.originName = item.name;
      this.populatePortPair();
    } else if (type === 'destination') {
      this.destinationId = item.id;
      this.destinationName = item.name;
      this.populatePortPair();
    } else if (type === 'port') {
      this.populatePort(item);
    } else if (type === 'vessel') {
      this.populateVessel(item);
    }
  }

  toggleRoutes() {
    this.showRoutes = !this.showRoutes;
  }

  onSaved(schedule: any) {
    this.onStatusChange('saved');
    this.scheduleId = schedule.id === null ? this.scheduleId : schedule.id;
    this.savedEmailSchedule = schedule;
    this.savedScheduleType = schedule.type;
    this.onScheduleChange(this.savedEmailSchedule);
  }

  populatePortPair() {
    try {
      if (this.originName === null || this.originName === '' || this.originName === undefined || this.originId === 0) {
        return;
      }

      if (this.destinationName === null || this.destinationName === '' || this.destinationName === undefined || this.destinationId === 0) {
        return;
      }

      if (this.savedEmailSchedule.id === this.scheduleId && this.destinationId === this.savedEmailSchedule.destinationPortId && this.originId === this.savedEmailSchedule.originPortId) {
        return;
      }
    } catch (ex) {
      // saved is not a portPair
    }

    let params = {};
    if (!+this.scheduleId) {
      params = {
        scheduleId: this.scheduleId
      };
    }

    let body = {
      scheduleId: this.scheduleId,
      type: 'portPair',
      originPortId: this.originId,
      destinationPortId: this.destinationId
    };
    this.onStatusChange('saving');
    this.service.set(params, body).then((schedule: any) => {
      schedule.originPort = {
        id: this.originId,
        name: this.originName
      };
      schedule.destinationPort = {
        id: this.destinationId,
        name: this.destinationName
      };
      this.onSaved(schedule);
    }).catch(err => {
      this.onStatusChange('error');
    });
  }

  populatePort(port: any) {
    try {
      if (port === null || port === undefined || port.id === 0 || port.id === null || port.id === undefined) {
        return;
      }
      if (this.savedEmailSchedule.id === this.scheduleId && port.id === this.savedEmailSchedule.port.id) {
        return;
      }
    } catch (ex) {
    }

    let params = {};
    if (!+this.scheduleId) {
      params = {
        scheduleId: this.scheduleId
      };
    }

    let body = {
      scheduleId: this.scheduleId,
      type: 'port',
      portId: port.id
    };
    this.onStatusChange('saving');
    this.service.set(params, body).then((schedule: any) => {
      schedule.port = port;
      this.onSaved(schedule);
    }).catch(err => {
      this.onStatusChange('error');
    });
  }

  populateVessel(vessel: any) {
    try {
      if (vessel === null || vessel === undefined || vessel.id === 0 || vessel.id === null || vessel.id === undefined) {
        return;
      }
      if (this.savedEmailSchedule.id === this.scheduleId && vessel.id === this.savedEmailSchedule.vessel.id) {
        return;
      }
    } catch (ex) {
    }

    let params = {};
    if (!+this.scheduleId) {
      params = {
        scheduleId: this.scheduleId
      };
    }

    let body = {
      scheduleId: this.scheduleId,
      type: 'vessel',
      vesselId: vessel.id
    };
    this.onStatusChange('saving');
    this.service.set(params, body).then((schedule: any) => {
      schedule.vessel = vessel;
      this.onSaved(schedule);
    }).catch(err => {
      this.onStatusChange('error');
    });
  }

  populateRoute(route: any) {
    this.showRoutes = false;

    this.inputOne = route.originName;
    this.originId = route.originId;
    this.originName = route.originName;
    this.inputTwo = route.destinationName;
    this.destinationId = route.destinationId;
    this.destinationName = route.destinationName;

    let params = {};
    if (!+this.scheduleId) {
      params = {
        scheduleId: this.scheduleId
      };
    }
    let body = {
      scheduleId: this.scheduleId,
      type: 'portPair',
      originPortId: this.originId,
      destinationPortId: this.destinationId
    };
    this.onStatusChange('saving');
    this.service.set(params, body).then((schedule: any) => {
      schedule.originPort = {
        id: this.originId,
        name: this.originName
      };
      schedule.destinationPort = {
        id: this.destinationId,
        name: this.destinationName
      };
      this.onSaved(schedule);
    }).catch(err => {
      this.onStatusChange('error');
    });
  }

  clear() {
    this.inputOne = '';
    this.originId = 0;
    this.originName = '';
    this.inputTwo = '';
    this.destinationId = 0;
    this.destinationName = '';
  }

  portPair() {
    this.message = '';
    if (this.scheduleType !== 'portPair') {
      this.clear();
    }
    if (this.savedScheduleType === 'portPair') {
      this.inputOne = this.savedEmailSchedule.originPort.name;
      this.originId = this.savedEmailSchedule.originPort.id;
      this.originName = this.savedEmailSchedule.originPort.name;
      this.inputTwo = this.savedEmailSchedule.destinationPort.name;
      this.destinationId = this.savedEmailSchedule.destinationPort.id;
      this.destinationName = this.savedEmailSchedule.destinationPort.name;
    }
    this.scheduleType = 'portPair';
  }

  vessel() {
    this.message = '';
    if (this.scheduleId !== 'vessel') {
      this.clear();
    }
    if (this.savedScheduleType === 'vessel') {
      this.inputOne = this.savedEmailSchedule.vessel.name;
    }
    this.scheduleType = 'vessel';
  }

  singlePort() {
    this.message = '';
    if (this.scheduleType !== 'port') {
      this.clear();
    }
    if (this.savedScheduleType === 'port') {
      this.inputOne = this.savedEmailSchedule.port.name;
    }
    this.scheduleType = 'port';
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/email-delivery/email-schedule/email-schedule.component.ts